import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-carousel-css.css?inline';

const CName = 'ui-carousel-css';

/**
 * @param {string} padding - This padding will be applied to the start and end of the carousel.
 */
@customElement(CName)
export class UICarouselCss extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: String }) padding = '0';

  render() {
    const inlineStyle = `--_padding:${this.padding}`;
    return html`
      <div class="carousel-container" style=${inlineStyle}>
        <div class="carousel-wrapper">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UICarouselCss;
  }
}
